import { render } from "./ListInstances.vue?vue&type=template&id=2f63ddc6&scoped=true&ts=true"
import script from "./ListInstances.vue?vue&type=script&lang=ts"
export * from "./ListInstances.vue?vue&type=script&lang=ts"

import "./ListInstances.vue?vue&type=style&index=0&id=2f63ddc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f63ddc6"]])

export default __exports__